import { useRef } from "react";
import { askForGroupAddressUpdate } from "../addressGeneration/addressGenerator";
import { serverConvertionMessages, resetExportState, downloadEtsProject } from "../etsFunctions/etsConvertViaServer";
import { reopenEtsDialog } from "../etsFunctions/etsFunctions";
import { ExportState } from "../models/ProjectMetadata";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import { showErrToast, showToast } from "./Toasts";
import { uploadProjectForConversion } from "./ProjectSelection/functions";
import { itx } from "../translationItx/itx";
import { ProjectLicenseType } from "../models/ProjectLicense.ts";
import ToShopLicensesDialog from "../modelDialogs/ToShopLicensesDialog.tsx";

export default function ExportEtsProjectViaServerButton() {
  // conversionStartedRef tracks whether the current conversion was started
  // while this button instance was visible — used to trigger auto-download.
  const conversionStartedRef = useRef(false);

  // Re-render when exportState changes. The callback fires the auto-download
  // exactly once when state transitions to WaitingForDownload.
  useOnChangeWatcher(state.projectMetadata, (prop) => {
    if (
      prop === "exportState" &&
      state.projectMetadata.exportState === ExportState.WaitingForDownload &&
      conversionStartedRef.current
    ) {
      conversionStartedRef.current = false;
      (async () => {
        await downloadEtsProject();
        showToast({ text: itx("homePage.fileDownloaded", "Project File Downloaded.") }); // no itx
        reopenEtsDialog();
      })();
    }
    return true;
  });

  // ---------------- UI Rendering ----------------

  ///////////// if (statusOverlay) return <StatusOverlay exportState={state.projectMetadata.exportState} />;
  let buttonText = "";
  let onClick = async (e) => {};
  let style = {};
  let iconClassName = "";

  switch (state.projectMetadata.exportState) {
    case ExportState.WaitingForDownload:
      ///       showToast({ : serverConvertionMessages.ready.replaceAll("T1", state.projectMetadata.name) });
      onClick = async (e) => downloadEtsProject();
      buttonText = serverConvertionMessages.download;
      iconClassName = "las la-download mr-1";
      break;

    case ExportState.Failure:
      onClick = async (e) => {
        resetExportState();
      };
      buttonText = itx("ExportEtsProjectViaServerButton.fehlerklickezum", "Fehler, Klicke zum Quitieren");
      iconClassName = "las la-download mr-1";
      style = { backgroundColor: "red" };
      break;

    case ExportState.WaitingForUploadReady:
    case ExportState.WaitingForConversion:
      //
      // waiting for conversion
      //
      onClick = async (e) => {};
      buttonText = serverConvertionMessages.waiting;
      iconClassName = "las la-hourglass-half mr-1";
      break;

    default:
      // Upload for Conversion
      onClick = async (e) => {
        e.stopPropagation();
        state.projectMetadata.statistic.numberOfEtsExports++;
        state.projectMetadata.raiseOnChange("statistic");
        try {
          //  check first if license is up to date
          if (!state.projectLicense.checkLicenses(ProjectLicenseType.EtsExport)) {
            state.dialogManager.openDialog(<ToShopLicensesDialog />);
            return;
          }
          // if license ok proceed

          const shouldContinue = await askForGroupAddressUpdate(true);
          if (!shouldContinue) return;
          await uploadProjectForConversion();
          conversionStartedRef.current = true;
        } catch {
          showErrToast(serverConvertionMessages.offline);
        }
      };
      buttonText = serverConvertionMessages.export;
      iconClassName = "las la-upload mr-1";
      break;
  }
  return (
    <button className="button" style={{ width: "100%", ...style }} onClick={onClick}>
      <i className={iconClassName}></i>
      {buttonText}
    </button>
  );
}
